import React, { useEffect, useState, useCallback } from "react";
import { supabase } from "../../supabaseClient";
import LoaderBox from "../HomePage/LoaderBox";
import { motion } from "framer-motion";
import Navigation from "../Navigation/Navigation";
import HomeFooter from "../HomePage/HomeFooter";
import { useParams } from "react-router-dom";
import BottomNavigation from "../Navigation/BottomNavigation";

const Sponsors = () => {
  const { turnirSlug } = useParams();
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);

  // Stanje za informacije o turniru (isto kao u HomePage)
  const [turnirInfo, setTurnirInfo] = useState({
    id: null,
    naziv: "",
    logo_url: "",
    lokacija: "",
    naziv_lokacije: "",
    features: {},
  });

  const fetchSponsorsData = useCallback(async () => {
    if (!turnirSlug) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);

      // 1. Dohvaćamo sve potrebne podatke o turniru preko sluga (uključujući naziv, logo, lokaciju i features)
      const { data: turnirData, error: turnirError } = await supabase
        .from("admin_turniri")
        .select("id, slug, naziv, logo_url, lokacija, naziv_lokacije, features")
        .eq("slug", turnirSlug)
        .single();

      if (turnirError || !turnirData) {
        console.error("Turnir nije pronađen:", turnirError?.message);
        setLoading(false);
        return;
      }

      // Spremamo informacije o turniru u state
      setTurnirInfo({
        id: turnirData.id,
        naziv: turnirData.naziv || "",
        logo_url: turnirData.logo_url || "",
        lokacija: turnirData.lokacija || "",
        naziv_lokacije: turnirData.naziv_lokacije || "",
        features: turnirData.features || {},
      });

      // 2. Dohvaćamo sponzore za ovaj turnir koristeći pronađeni ID
      const { data: sponsorsData, error: sponsorsError } = await supabase
        .from("admin_sponzori")
        .select("*")
        .eq("turnir_id", turnirData.id)
        .eq("is_visible", true)
        .order("position", { ascending: true });

      if (sponsorsError) throw sponsorsError;

      setSponsors(sponsorsData || []);
    } catch (error) {
      console.error("Greška pri dohvaćanju podataka:", error.message);
    } finally {
      setLoading(false);
    }
  }, [turnirSlug]);

  useEffect(() => {
    fetchSponsorsData();
  }, [fetchSponsorsData]);

  if (loading) return <LoaderBox text="Učitavanje sponzora..." />;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <>
      {/* Proslijeđujemo sve podatke o turniru u Navigation, točno kao u HomePage */}
      <Navigation
        turnirSlug={turnirSlug}
        turnirNaziv={turnirInfo.naziv}
        turnirLogo={turnirInfo.logo_url}
        lokacija={turnirInfo.lokacija}
        nazivLokacije={turnirInfo.naziv_lokacije}
        features={turnirInfo.features}
      />

      <section className="sponsors-page-wrapper">
        <div className="sponsors-header">
          <h3>Službeni Sponzori</h3>
          <p>Zahvaljujemo partnerima koji podržavaju turnir</p>
        </div>

        {sponsors.length === 0 ? (
          <div
            className="no-sponsors-placeholder"
            style={{ textAlign: "center", color: "#aaa", marginTop: "40px" }}
          >
            <p>Trenutno nema istaknutih sponzora za ovaj turnir.</p>
          </div>
        ) : (
          <motion.div
            className="sponsors-grid"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {sponsors.map((sponsor) => (
              <motion.a
                href={sponsor.web_url || "#"}
                key={sponsor.id}
                className="sponsor-card"
                target={sponsor.web_url ? "_blank" : "_self"}
                rel="noopener noreferrer"
                style={{ "--brand-color": sponsor.bg_color || "#FFF" }}
                variants={itemVariants}
              >
                <div className="logo-wrapper">
                  <img src={sponsor.logo_url} alt={sponsor.name} />
                </div>
              </motion.a>
            ))}
          </motion.div>
        )}
      </section>
      <BottomNavigation />
      <HomeFooter />
    </>
  );
};

export default Sponsors;
